import { render, staticRenderFns } from "./ProfileArticlesTeaser.vue?vue&type=template&id=092e470f&"
import script from "./ProfileArticlesTeaser.vue?vue&type=script&lang=js&"
export * from "./ProfileArticlesTeaser.vue?vue&type=script&lang=js&"
import style0 from "./ProfileArticlesTeaser.vue?vue&type=style&index=0&id=092e470f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports